import type { ParsedRuntimeGlb } from './types';

export async function parseWithGltfLoader(arrayBuffer: ArrayBuffer): Promise<ParsedRuntimeGlb> {
  const { GLTFLoader } = await import('three/examples/jsm/loaders/GLTFLoader.js');

  const loader = new GLTFLoader();
  const parsed = await loader.parseAsync(arrayBuffer, '');

  return {
    scene: parsed.scene,
    scenes: parsed.scenes,
    animations: parsed.animations,
    cameras: parsed.cameras,
  };
}
